import { render } from "./Countdown.vue?vue&type=template&id=71adeff1&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=71adeff1&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71adeff1"]])

export default __exports__